export type ProductParameter = {
  id: number
  name: string
}

export type Product = {
  slug: string
  id: string
  title: string
  order: number
  bids_count: number
  parameters: ProductParameter[] | []
  main_parameter: ProductParameter | null
}

export type CompanyDadata = {
  inn: string
  kpp: string
  name_short: string
  name_full: string
  address_short: string
  address_full: string
  legal_form?: {
    short?: string
    full?: string
    [x: string]: any
  }
  legal_type?: string
  [x: string]: any
}

export type Team = {
  id: string
  name: string
}

export type Region = {
  id: string
  name: string
  parent_id: string | null
}

export type ProductFuturesSymbol = {
  id: string
  symbol: string
  product: number
}

export enum LegalType {
  INDIVIDUAL = 'INDIVIDUAL',
  LEGAL = 'LEGAL',
}
